import React from "react";
import token from "../../assets/token.png";
import vector1 from "../../assets/vector1.png";
import vector2 from "../../assets/vector2.png";
import "./token.css";

const Token = () => {
  return (
    <section className="token">
      <img className="token-img" src={token} alt="Token" />
      <div className="token-content">
        <h2 className="token-title">
          <img className="vector" src={vector1} alt="vector1" />
          {""} Dante Token {""}
          <img className="vector" src={vector2} alt="vector2" />
        </h2>
        <p className="token-description">
        Dante Token is a coin issued on the Solana blockchain. <br />
        It was launched via pump.fun, ensuring an open-market and fair <br />
        distribution. While the token is market-driven, it will also serve as a utility <br />
        token within the DanteGPU ecosystem. Users can pay with either Dante <br />
        Token or Stablecoins, but using Dante Token will come with benefits such <br />
        as discounts and incentives.

        </p>
      </div>
    </section>
  );
};

export default Token;
